/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItem
 */
export interface DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItem {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItem
     */
    name?: string | null;
}

export function DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItemFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItem {
    return DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItemFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItemToJSON(value?: DigitizingserviceMelcoDigitizingModelsEmbStitchFormatListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


